import { useEffect } from "react";


const Backtotop =()=>{
    let mybutton = null;
    useEffect(()=>{
     mybutton = document.getElementById("btn-back-to-top");
     mybutton.addEventListener("click", backToTop);
    })


window.onscroll = function () {
  scrollFunction();
};

function scrollFunction() {
  if (
    document.body.scrollTop > 20 ||
    document.documentElement.scrollTop > 20
  ) {
    mybutton.style.display = "block";
  } else {
    mybutton.style.display = "none";
    
  }
}


function backToTop() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}
return (
    <>
    <button type="button" className="primary-btn btn-floating btn-sm"  id="btn-back-to-top"   >
                   <i className="fa fa-arrow-up fa-fw fa-xl"></i>
    </button>
    </>
)

}

export default Backtotop;
